import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})

export class RefineryBalanceService {
    constructor(protected http: HttpClient) {

    }

    baseurl = environment.apiBaseUrl + 'RefineryBalance';

    GetRefineryBalances() {
        return this.http.get<any[]>(this.baseurl + '/GetRefineryBalancesAsync');
    }

    GetRefineryBalancesBySite(siteId: number) {
        return this.http.get<any[]>(this.baseurl + '/GetRefineryBalancesBySiteAsync/' + siteId);
    }

    GetRefiningSiteProductionFacilityPipelineSummary(siteId: number) {
        return this.http.get<any[]>(this.baseurl + '/GetRefiningSiteProductionFacilityPipelineSummary/' + siteId);
    }
}